var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DoughnutChart',{staticClass:"tag-doughnut-chart",attrs:{"chart-data":_vm.processedChartData,"options":_vm.options,"grouping-name":_vm.$t(`groupByKeys.${_vm.groupByKey}`),"exportable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }